import React from "react";
import { Typography, Button, Box } from "@mui/material";
import ResourceListContent from "./ResoureListContent";
import { useNavigate } from "react-router-dom";

function Resources() {
    const navigate = useNavigate();

    const handleAddResource = () => {
        navigate('/resources/add');
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Resources are essential ...
            </Typography>
            <Button onClick={handleAddResource} variant="contained" color="primary">
                Add New Resource
            </Button>
            <Box sx={{ mt: 2 }}>
                <Typography variant="body1" gutterBottom>
                    List of resources and websites ...
                </Typography>
                <ResourceListContent />
            </Box>
        </Box>
    );
}

export default Resources;
